import React from "react";
import {FileInputContainerStyles} from "../styles/FileInput";
import Button from "../Button/Button";
import {CloseCrossStyles} from "../styles/CloseCross";
import {ErrorMessage} from "../styles/ErrorMessag";
import PropTypes from "prop-types";

const FileInput = React.forwardRef(({file, fileSelect, clear, errorMessage, setErrorMessage}, ref) => {
	const openFileSelect = () => {
		setErrorMessage(null);
		ref.current && ref.current.click();
	};

	return (
		<div>
			<FileInputContainerStyles>
				<input type="file" onChange={fileSelect} ref={ref} accept=".xlsx,.xls"/>
				<Button onClick={openFileSelect}>Импорт из XLSX</Button>
				{file ? <div className="file__info">
					<span>{file.name}</span>
					<button className="file__clear" onClick={clear}><CloseCrossStyles/></button>
				</div> : null}
			</FileInputContainerStyles>
			{errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
		</div>
	)
});

FileInput.displayName = 'FileInput';

FileInput.propTypes = {
	file: PropTypes.object,
	fileSelect: PropTypes.func,
	clear: PropTypes.func,
	errorMessage: PropTypes.string,
	setErrorMessage: PropTypes.func,
};

export default FileInput;